// CSS Imports
import './css/bootstrap.min.css';
import './css/main.css';
import './css/theme-dark.css';
import './css/new.css';
import Index from './pages/index.js';
import SingleProject from './pages/singleproject.js';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
function App() {
    return (
        <Router>
            <Routes>
                <Route exact path='/' element={<Index />} />
                <Route exact path='/project' element={<SingleProject />} />
            </Routes>
        </Router>
    )
}

export default App;
